/* claude- (2026-09-28) The how-many picker behind every glass Add to cart (cards, the pop-out, the
   collection hero). Adam: "add to cart will pop up a selector for how many with the 3Pc Minumum at the
   top the quntity selector in the middle with 3 already in there then below that add 6,12,24".
   Wholesale is 3 of a style at least, so the stepper starts at 3 and its minus only shows at 4 or more.
   window.ccQtyPicker(variantId, name) opens it; the add goes to /cart/add.js and the cart drawer opens. */
(function () {
  'use strict';
  var MIN = 3, el, input, nameEl, msg, vid = null;
  /* stickers have no minimum (Adam, 2026-09-28: "stickers don't need the 3 minimum"); pass min 1 */
  function sync() {
    var v = parseInt(input.value, 10);
    el.classList.toggle('is-min', !(v > MIN));
  }
  function close() {
    if (!el) return;
    el.hidden = true;
    document.documentElement.classList.remove('ccqp-open');
  }
  function busy(on) { el.querySelectorAll('button').forEach(function (b) { if (!b.hasAttribute('data-x')) b.disabled = on; }); }
  function add(q) {
    q = parseInt(q, 10);
    if (!(q >= MIN)) { input.value = MIN; sync(); msg.textContent = 'The minimum is ' + MIN + ' per style.'; return; }
    busy(true);
    msg.textContent = 'Adding ' + q + '…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: q }] })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { msg.textContent = res.j.description || 'Could not add that many.'; return; }
        close();
        if (typeof window.claudeCartOpen === 'function') window.claudeCartOpen();
      })
      .catch(function () { msg.textContent = 'Could not add to the cart. Please try again.'; })
      .finally(function () { busy(false); });
  }
  function build() {
    el = document.createElement('div');
    el.className = 'ccqp';
    el.hidden = true;
    el.innerHTML =
      '<div class="ccqp__scrim" data-x></div>' +
      '<div class="ccqp__box" role="dialog" aria-modal="true" aria-labelledby="ccqp-title">' +
        '<button type="button" class="ccqp__close" data-x aria-label="Close">&times;</button>' +
        '<p class="ccqp__min" id="ccqp-title">3 Pc Minimum</p>' +
        '<p class="ccqp__name"></p>' +
        '<div class="ccqp__step">' +
          '<button type="button" class="ccqp__dq" aria-label="Decrease quantity">&minus;</button>' +
          '<input type="number" inputmode="numeric" min="3" step="1" value="3" aria-label="Quantity">' +
          '<button type="button" class="ccqp__iq" aria-label="Increase quantity">+</button>' +
        '</div>' +
        '<button type="button" class="ccqp__add" data-add>Add to cart</button>' +
        '<div class="ccqp__quick">' +
          '<button type="button" data-q="6">Add 6</button>' +
          '<button type="button" data-q="12">Add 12</button>' +
          '<button type="button" data-q="24">Add 24</button>' +
        '</div>' +
        '<p class="ccqp__msg" aria-live="polite"></p>' +
      '</div>';
    document.body.appendChild(el);
    input = el.querySelector('input');
    nameEl = el.querySelector('.ccqp__name');
    msg = el.querySelector('.ccqp__msg');
    el.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-x]')) return close();
      if (t.closest('.ccqp__iq')) { input.value = (parseInt(input.value, 10) || MIN) + 1; sync(); }
      else if (t.closest('.ccqp__dq')) { input.value = Math.max(MIN, (parseInt(input.value, 10) || MIN) - 1); sync(); }
      else if (t.closest('[data-add]')) add(input.value);
      else if (t.closest('[data-q]')) add(t.closest('[data-q]').getAttribute('data-q'));
    });
    input.addEventListener('input', sync);
    input.addEventListener('change', function () { if (!(parseInt(input.value, 10) >= MIN)) input.value = MIN; sync(); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); add(input.value); } });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !el.hidden) close(); });
  }
  window.ccQtyPicker = function (variantId, name, min) {
    if (!variantId) return;
    if (!el) build();
    vid = variantId;
    MIN = min > 0 ? min : 3;
    input.min = MIN;
    el.querySelector('.ccqp__min').textContent = MIN > 1 ? MIN + ' Pc Minimum' : 'How many?';
    input.value = MIN;
    nameEl.textContent = name || '';
    nameEl.hidden = !name;
    msg.textContent = '';
    sync();
    el.hidden = false;
    document.documentElement.classList.add('ccqp-open');
    el.querySelector('[data-add]').focus({ preventScroll: true });
  };
})();
